"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.Column = exports.Row = exports.Container = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const flat_1 = require("../../shared/utils/flat");
const CardColumn = styled_components_1.default.div `
  height: 100%;
  width: 100%;

  &:first-child {
    color: ${({ theme }) => theme.colors.greyLighten40};
  }
  &:not(:first-child):last-child {
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
exports.Column = CardColumn;
CardColumn.displayName = "Card.Column";
const CardRow = styled_components_1.default.div.attrs((props) => ({
    align: props.align || "left",
    columns: props.columns || 0,
    isTitle: props.isTitle || "",
    border: props.border
})) `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  padding: ${({ theme }) => theme.spacings.m}
    ${({ theme }) => theme.spacings.xl};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  text-align: ${({ align }) => (align ? align : "left")};
  line-height: ${({ theme }) => theme.spacings.xl};

  p {
    color: ${({ theme }) => theme.colors.greyBase};
    line-height: ${({ theme }) => theme.spacings.xl};
  }

  p:last-child {
    margin-bottom: 0;
  }

  button,
  .button {
    margin-bottom: ${({ theme }) => theme.spacings.m};

    &:last-child {
      margin-bottom: 0;
    }
  }

  img {
    height: 1.5rem;
    display: inline-block;
    margin-right: ${({ theme }) => theme.spacings.m};
    float: left;
  }

  ${({ isTitle }) => isTitle
    ? "& {font-weight: 500; &:first-child { *:not(img) {font-weight: 600; position: relative;top: 2px;} a {font-weight: 500;}}"
    : ""}

  & > div:first-of-type {
    ${({ isTitle, theme }) => isTitle ? `color: ${theme.colors.greyBase}` : ""};
  }

  ${({ border }) => border === false ? "border-bottom: none !important;" : ""}

  ${({ columns }) => columns
    ? `
     display: grid;
     align-items: baseline;
     grid-template-columns: repeat(${columns}, 1fr);     
  `
    : ""};

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.spacings.m}
      ${({ theme }) => theme.spacings.m};
  }
`;
const TitleRight = styled_components_1.default.span `
  line-height: ${({ theme }) => theme.spacings.xl};
  position: absolute;
  right: ${({ theme }) => theme.spacings.xl};
  top: ${({ theme }) => theme.spacings.m};
  cursor: pointer;
  user-select: none;
  font-weight: 500;
`;
const CardToggler = (0, styled_components_1.default)(TitleRight) `
  top: ${({ theme }) => theme.spacings.m};
`;
const Card = styled_components_1.default.div `
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  background-color: ${({ theme }) => theme.colors.whiteBase};
  position: relative;
  overflow: hidden;

  a {
    text-decoration: underline;
    font-size: 1rem;
  }

  ${CardRow} {
    &:last-child {
      border-bottom: none;
    }

    ${CardRow} {
      padding-left: 0;
      padding-right: 0;
      border-color: ${({ theme }) => theme.colors.silverLighten70};
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
      }
    }
  }

  &[data-collapsable="true"] .title {
    cursor: pointer;
  }
`;
const countCardColumns = (children) => {
    let columns = 0;
    [children].reduce(flat_1.flat, [])
        .filter((child) => !!child)
        .forEach((child) => { var _a; return ((_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "Card.Column" && columns++; });
    return columns;
};
const Row = ({ align, border, children, className }) => {
    if (!children) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(CardRow, { columns: countCardColumns(children), align: align, border: border, className: className, children: children }, void 0));
};
exports.Row = Row;
Row.displayName = "Card.Row";
const Title = ({ children }) => ((0, jsx_runtime_1.jsx)(CardRow, { columns: countCardColumns(children), isTitle: true, "data-title": "true", className: "title", children: children }, void 0));
exports.Title = Title;
Title.displayName = "Card.Title";
const reducer = (state, action) => {
    switch (action.type) {
        case "open":
            return { ...state, open: true };
        case "close":
            return { ...state, open: false };
        case "toggle":
            return { ...state, open: !state.open };
        default:
            throw new Error();
    }
};
const Container = ({ open = true, collapsable = false, title, titleRight, children }) => {
    const [state, dispatch] = (0, react_1.useReducer)(reducer, { open });
    (0, react_1.useEffect)(() => {
        dispatch({ type: open ? "open" : "close" });
    }, [open]);
    const nChildren = [];
    if (title) {
        nChildren.push((0, jsx_runtime_1.jsx)(Title, { children: title }, `${title}-0`));
    }
    [children].reduce(flat_1.flat, []).forEach((child, i) => {
        var _a, _b;
        nChildren.push(((_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "Card.Row" ||
            ((_b = child.type) === null || _b === void 0 ? void 0 : _b.displayName) === "Card.Title"
            ? child
            : (0, react_1.createElement)(Row, { key: `${title}-${i + 1}` }, child));
    });
    const toggleCollapse = (e) => {
        e.stopPropagation();
        if (e.target.classList.contains("title") &&
            collapsable) {
            dispatch({ type: "toggle" });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Card, { "data-open": state.open, "data-collapsable": collapsable, "data-component": "card", onClick: toggleCollapse, children: [collapsable && !titleRight && ((0, jsx_runtime_1.jsx)(CardToggler, { onClick: () => dispatch({ type: "toggle" }), children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: state.open ? ["fas", "caret-up"] : ["fas", "caret-down"], color: "grey", size: "lg" }, void 0) }, void 0)), !collapsable && titleRight && (0, jsx_runtime_1.jsx)(TitleRight, { children: titleRight }, void 0), state.open && nChildren, !state.open && nChildren.shift()] }, void 0));
};
exports.Container = Container;
exports.default = Container;
//# sourceMappingURL=card.js.map